//Compliance

export const GetAllMembers = (id) => {
  return $.get('Patron/GetAllMembers?LocationId='+id)
}

export const GetMemberDetails = (id) => {
  return $.get('Patron/GetMemberDetails?MemberId='+id)
}

export const AddMember = (model) => {
  return $.post('Patron/AddMember', model)
}

export const UpdateMember = (model) => {

  return $.post('Patron/UpdateMember', model)
}



export const DeleteMember = (id) => {
  return $.post('Patron/DeleteMember?MemberId=' + id)
}







// WEBPACK FOOTER //
// ./src/pages/Patrons/patrons.service.js